import { Link } from "react-router-dom";
import routes from "@/routers/routes";
import { Button } from "rizzui";
import PageHeader from "@/app/shared/page-header";
import OrdersTable from "@/app/shared/ecommerce/order/order-list/table";
import { PiPlusBold } from "react-icons/pi";
import { orderData } from "@/data/order-data";
import { metaObject } from "@/config/site.config";
import ExportButton from "@/app/shared/export-button";

export const metadata = {
  ...metaObject("Orders"),
};

const pageHeader = {
  title: "Orders",
  breadcrumb: [
    {
      href: routes.eCommerce.dashboard,
      name: "E-Commerce",
    },
    {
      href: routes.eCommerce.orders,
      name: "Orders",
    },
    {
      name: "List",
    },
  ],
};

export default function OrdersPage() {
  return (
    <>
      <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
        <div className="mt-4 flex items-center gap-3 @lg:mt-0">
          <ExportButton
            data={orderData}
            fileName="order_data"
            header="Order ID,Name,Email,Avatar,Items,Price,Status,Created At,Updated At"
          />
          <Link
            to={routes.eCommerce.createProduct}
            className="w-full @lg:w-auto"
          >
            <Button as="span" className="w-full @lg:w-auto">
              <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
              Add Order
            </Button>
          </Link>
        </div>
      </PageHeader>

      <OrdersTable />
    </>
  );
}
